<template>
  <div class="relative inline-block border border-neutral-400 rounded-full">
    <VDatePicker
      ref="datePicker"
      v-model="dateValue"
      :is-range="isRange"
      @update:model-value="onSelectDate"
      @did-show="$emit('opened')"
    >
      <template #default="{ togglePopover }">
        <button
          type="button"
          :data-testid="dataTestid"
          @click="togglePopover"
          class="flex items-center gap-2 px-4 py-2 rounded-full text-sm text-neutral-400 hover:bg-gray-100"
        >
          <CalendarIcon :width="16" :height="16" color="#7F7F7F" />
          <span>{{ title }}</span>
        </button>
      </template>
    </VDatePicker>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import CalendarIcon from '@/assets/icons/calendar.vue'

interface DateRange {
  start: Date | null
  end: Date | null
}

defineOptions({ inheritAttrs: false })

const props = withDefaults(
  defineProps<{
    title?: string
    isRange?: boolean
    modelValue?: DateRange | Date | null
    dataTestid?: string
  }>(),
  {
    title: 'Data',
    isRange: true,
    modelValue: null,
    dataTestid: undefined
  }
)

const emit = defineEmits<{
  (e: 'select', payload: DateRange): void
  (e: 'opened'): void
}>()

const datePicker = ref<any>(null)

const dateValue = ref<any>(props.modelValue ?? (props.isRange ? { start: null, end: null } : null))

watch(
  () => props.modelValue,
  (val) => {
    dateValue.value = val ?? (props.isRange ? { start: null, end: null } : null)
  }
)

function onSelectDate(val: any) {
  if (!val) return

  if (props.isRange) {
    if (val.start && val.end) {
      val.start.setHours(0, 0, 0, 0)
      val.end.setHours(23, 59, 59, 999)
      emit('select', { start: val.start, end: val.end })
      datePicker.value?.hidePopover()
    }
  } else {
    const start = new Date(val)
    start.setHours(0, 0, 0, 0)

    const end = new Date(val)
    end.setHours(23, 59, 59, 999)

    emit('select', { start, end })
    datePicker.value?.hidePopover()
  }
}

function close() {
  datePicker.value?.hidePopover()
}

// Sem isso, limpar o filtro de período pela tela deixa o intervalo preso no
// v-model interno do picker — e reselecionar o mesmo range não emite `select`.
// Mesmo contrato do ValueRangeFilter.reset().
function reset() {
  dateValue.value = props.isRange ? { start: null, end: null } : null
}

defineExpose({
  close,
  reset
})
</script>

<style scoped>
.vc-popover-content-wrapper {
  z-index: 9999 !important;
}
</style>
